<div class="d-flex flex-column h-100 bg-light">
  <div class="bg-white border-bottom px-3 py-2">
    <div class="d-flex align-items-center">
      <mat-icon color="primary" class="mr-2 flex-shrink-0">{{ preview.icon(current) }}</mat-icon>
      <div class="overflow-hidden flex-grow-1">
        <div class="font-weight-bold text-dark text-truncate" [matTooltip]="current?.title">{{ current?.title }}</div>
        @if (current?.reference) {
          <div class="small text-muted text-truncate">{{ current.reference }}</div>
        }
      </div>
      <button mat-flat-button color="primary" type="button" class="ml-2 flex-shrink-0 d-none d-md-inline-flex" (click)="close()">
        <mat-icon>close</mat-icon>
        {{ 'components.statement-documents.close' | translate }}
      </button>
      <button mat-icon-button type="button" class="ml-1 flex-shrink-0 d-md-none" (click)="close()"
        [attr.aria-label]="'components.statement-documents.close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="d-flex flex-wrap align-items-center justify-content-center mt-1">
      @if (data.attachments.length > 1) {
        <div class="d-flex align-items-center mx-2">
          <button mat-icon-button type="button" [disabled]="index === 0" (click)="previousDocument()"
            [matTooltip]="'components.statement-documents.previous-document' | translate">
            <mat-icon>skip_previous</mat-icon>
          </button>
          <span class="small text-muted text-nowrap">{{ 'components.statement-documents.document-of' | translate: { n: index + 1, total: data.attachments.length } }}</span>
          <button mat-icon-button type="button" [disabled]="index === data.attachments.length - 1" (click)="nextDocument()"
            [matTooltip]="'components.statement-documents.next-document' | translate">
            <mat-icon>skip_next</mat-icon>
          </button>
        </div>
      }

      @if (kind === 'pdf' && !loading && !failed) {
        <div class="d-flex align-items-center mx-2">
          <button mat-icon-button type="button" [disabled]="page <= 1" (click)="goToPage(page - 1)"
            [matTooltip]="'components.statement-documents.previous-page' | translate">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <input class="border rounded text-center px-1 py-1 small" style="width: 3.2rem" type="number" min="1" [max]="pageCount" [value]="page"
            (change)="goToPage($any($event.target).valueAsNumber)" [attr.aria-label]="'components.statement-documents.page' | translate">
          <span class="small text-muted text-nowrap pl-2">/ {{ pageCount }}</span>
          <button mat-icon-button type="button" [disabled]="page >= pageCount" (click)="goToPage(page + 1)"
            [matTooltip]="'components.statement-documents.next-page' | translate">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      }

      @if ((kind === 'pdf' || kind === 'image') && !loading && !failed) {
        <div class="d-flex align-items-center mx-2">
          <button mat-icon-button type="button" (click)="zoomOut()" [matTooltip]="'components.statement-documents.zoom-out' | translate">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <button mat-button type="button" class="px-2" (click)="resetZoom()" [matTooltip]="'components.statement-documents.zoom-reset' | translate">{{ zoomPercent }}%</button>
          <button mat-icon-button type="button" (click)="zoomIn()" [matTooltip]="'components.statement-documents.zoom-in' | translate">
            <mat-icon>zoom_in</mat-icon>
          </button>
        </div>
      }

      @if (canDownload) {
        <button mat-icon-button type="button" class="mx-1" (click)="download()" [matTooltip]="'components.statement-documents.download' | translate">
          <mat-icon>download</mat-icon>
        </button>
      }
    </div>
  </div>

  <div #stage class="flex-grow-1 overflow-auto p-4 text-center" style="min-height: 0"
    [class.user-select-none]="current?.is_read_only" (contextmenu)="blockContextMenu($event)">
    @if (loading) {
      <div class="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
        <mat-spinner diameter="36" strokeWidth="3" class="mb-3"></mat-spinner>
        {{ 'components.statement-documents.loading' | translate }}
      </div>
    } @else if (failed) {
      <div class="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
        <mat-icon color="warn" class="mb-2">error_outline</mat-icon>
        {{ 'components.statement-documents.load-error' | translate }}
      </div>
    } @else if (kind === 'docx') {
      <div class="bg-white shadow-sm rounded p-5 mx-auto text-left" style="max-width: 860px" [innerHTML]="docxHtml"></div>
    } @else if (kind === 'file' || kind === 'link' || kind === 'pubmed') {
      <mat-card appearance="outlined" class="d-inline-block text-center p-4 mt-5" style="max-width: 420px">
        <mat-icon color="primary" class="mb-2">{{ preview.icon(current) }}</mat-icon>
        <p class="mb-3">
          {{ (kind === 'file' ? 'components.statement-documents.no-preview' : 'components.statement-documents.external-hint') | translate }}
        </p>
        @if (kind !== 'file') {
          <button mat-flat-button color="primary" type="button" (click)="openExternal()">
            <mat-icon>open_in_new</mat-icon>
            {{ 'components.statement-documents.open-external' | translate }}
          </button>
        } @else if (canDownload) {
          <button mat-flat-button color="primary" type="button" (click)="download()">
            <mat-icon>download</mat-icon>
            {{ 'components.statement-documents.download' | translate }}
          </button>
        } @else {
          <p class="small text-muted mb-0">{{ 'components.statement-documents.read-only-note' | translate }}</p>
        }
      </mat-card>
    }
    <canvas #canvas class="bg-white shadow" [hidden]="loading || failed || (kind !== 'pdf' && kind !== 'image')"></canvas>
  </div>

  @if (current?.is_read_only) {
    <div class="d-flex align-items-center justify-content-center small text-muted bg-white border-top py-2">
      <mat-icon inline class="mr-1">lock</mat-icon>
      {{ 'components.statement-documents.read-only-note' | translate }}
    </div>
  }
</div>
